import type { DataPartRenderer } from '../lib/default-renderers';
import type { ShellArtifactRenderItem } from '../lib/shell-artifacts';

interface ShellArtifactCardsProps {
  artifacts: ShellArtifactRenderItem[];
  dataPartRenderers?: Record<string, DataPartRenderer>;
}

export function ShellArtifactCards({ artifacts, dataPartRenderers }: ShellArtifactCardsProps) {
  return artifacts.map(({ fileUuid, part, rendererKey }) => {
    const ArtifactRenderer = dataPartRenderers?.[rendererKey];
    return ArtifactRenderer ? <ArtifactRenderer key={fileUuid} part={part} /> : null;
  });
}
